import 'url-search-params-polyfill'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueCompositionAPI from '@vue/composition-api'
import VueAnalytics from 'vue-analytics'
import VueLoaders from 'vue-loaders'
import VueScrollTo from 'vue-scrollto'
import { VTooltip } from 'v-tooltip'
import { initializeBraze } from '@/utils'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { setupJsCommon } from '@internetworkexpert/js-common'
import mixpanelEvent from '@/helpers/mixins'
import App from './App.vue'
import store from './store'
import router from './router'

setupJsCommon(process.env.VUE_APP_ENVIRONMENT || 'production')

Bugsnag.start({
  apiKey: process.env.VUE_APP_BUGSNAG_KEY || '',
  releaseStage: process.env.VUE_APP_ENVIRONMENT,
  plugins: [new BugsnagPluginVue()],
  autoDetectErrors: false,
  enabledReleaseStages: ['production', 'staging', 'development'],
  appVersion: '2.38.1',
})
Vue.use(VueMeta)
Vue.use(VueLoaders)
Vue.use(VueScrollTo)
Vue.use(VueCompositionAPI)

Vue.mixin(mixpanelEvent)

Vue.use(VueAnalytics, {
  id: 'UA-610123-1',
  checkDuplicatedScript: true,
  router,
  ecommerce: {
    enabled: true,
    enhanced: false,
  },
})

Vue.directive('tooltip', VTooltip)

Vue.config.productionTip = false

initializeBraze()

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
